import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fc-img',
    templateUrl: './image.component.html',
    styleUrls: ['./image.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ImageComponent {
    @Input() src: string;
    @Input() alt: string;

    constructor() {}
}
